<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card tile>
      <v-toolbar card dark color="white">
        <v-btn icon dark @click.native="onCancel">
          <v-icon color="primary">close</v-icon>
        </v-btn>
        <v-toolbar-title><span class="toolbar-title">Take a photo</span></v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <camera @cancel="onCancel()" @save="$emit('image', $event); onCancel() " />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import Camera from './../camera'

export default {
  name:'camera-dialog',
  components: {
    Camera,
  },
  props: {
    open: Boolean,
  },
  data(){
    return {
      dialog: this.open,
    }
  },
  watch: {
    open(value) {
      this.dialog=value
    },
  },
  methods: {
    onCancel() {
      this.$emit('update:open', false)
    },
  },
}
</script>

<style scoped>
.toolbar-title {
  color: #0277BD;
  font-family: Raleway, sans-serif;
  font-weight: bold;
}
</style>
